import {
    createContext,
    PropsWithChildren,
    useCallback,
    useContext,
    useMemo,
    useState
} from "react";

type SearchPaletteContextType = {
    readonly isOpen: boolean;
    readonly open: () => void;
    readonly close: () => void;
    readonly toggle: () => void;
};

const SearchPaletteContext = createContext<
    SearchPaletteContextType | undefined
>(undefined);

export const SearchPaletteProvider: React.FC<PropsWithChildren> = ({
    children
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);
    const toggle = useCallback(() => setIsOpen((prev) => !prev), []);

    const value = useMemo(
        () => ({ isOpen, open, close, toggle }),
        [isOpen, open, close, toggle]
    );

    return (
        <SearchPaletteContext.Provider value={value}>
            {children}
        </SearchPaletteContext.Provider>
    );
};

export const useSearchPalette = (): SearchPaletteContextType => {
    const context = useContext(SearchPaletteContext);
    if (context === undefined) {
        throw new Error(
            "useSearchPalette must be used within SearchPaletteProvider"
        );
    }
    return context;
};
